var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"order-container"},[_c('OrderSearch',{attrs:{"stage":_vm.stage,"all":true,"search-task-state-visibility":true}}),_c('OrderList',{attrs:{"stage":_vm.stage,"all":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }